"use client";

import { usePathname } from "next/navigation";

import { NavbarClient } from "@/layout/global/navbar/Navbar.client";

export function HeaderChrome() {
	const pathname = usePathname();
	const isHomePage = pathname === "/";

	return (
		<header className={isHomePage ? "absolute inset-x-0 top-0 z-10" : "relative z-10"}>
			<NavbarClient />
		</header>
	);
}
